
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { separadorMillares } from "../../../hooks/useMillares";
import { useValidarRoles } from "../../../hooks";
import { VALOR_PRECIO } from "../../../data";



export const TablaModelarItems = ({ producto }) => {


    const { permitirXRol } = useValidarRoles();
    const validarRole = permitirXRol('SUPERADMIN', 'ADMINISTRADOR', 'DISTRIBUIDOR');


    const calcularColSpan = (producto) => {
        let colSpan = 2;
        if (producto.color) colSpan++;
        if (producto.genero) colSpan++;
        if (producto.ancho) colSpan++;
        if (producto.alto) colSpan++;
        if (producto.unidadMedida) colSpan++;
        if (producto.terminados) colSpan++;
        if (producto.talla) colSpan++;
        if (producto.disenio) colSpan++;
    
        if (validarRole) colSpan += 2;
        return colSpan;
    };



    return (

        <>
            {(producto) && 
            <TableContainer>
                <Table sx={{ minWidTableCell: 700, }}>
                    <TableHead>
                        <tr>
                            <TableCell sx={{backgroundColor:'secondary.main'}} colSpan={calcularColSpan(producto)}>
                                INFORMACIÓN DE ITEM
                            </TableCell>
                        </tr>
                    </TableHead>
                    <TableHead>
                        <TableRow>
                            <TableCell scope="col">Nombre Producto</TableCell>
                            <TableCell scope="col">Cantidad</TableCell>

                            {(producto.color) &&
                                <TableCell scope="col">Color</TableCell>
                            }

                            {(producto.genero) &&
                                <TableCell scope="col">Genero</TableCell>
                            }

                            {(producto.ancho) &&
                                <TableCell scope="col">Ancho</TableCell>
                            }

                            {(producto.alto) &&
                                <TableCell scope="col">Alto</TableCell>
                            }

                            {(producto.unidadMedida) &&
                                <TableCell scope="col">Uni. Medida</TableCell>
                            }

                            {(producto.terminados) &&
                                <TableCell scope="col">Terminados</TableCell>
                            }

                            {(producto.talla) &&
                                <TableCell scope="col">Talla</TableCell>
                            }

                            {(producto.disenio) &&
                                <TableCell scope="col">Diseño</TableCell>
                            }

                            {(validarRole) &&
                            <>
                                <TableCell scope="col">Valor Uni.</TableCell>
                                <TableCell scope="col">Total</TableCell>
                            </>
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>{ producto.producto.nombre }</TableCell>
                            <TableCell>{ producto.cantidad }</TableCell>
                            {(producto.color) &&
                                <TableCell>{ producto.color }</TableCell>
                            }

                            {( producto.genero ) &&
                                <TableCell>{ producto.genero }</TableCell>
                            }
                            {(producto.ancho) &&
                                <TableCell>{ producto.ancho }</TableCell>
                            }

                            {(producto.alto) &&
                                <TableCell>{ producto.alto }</TableCell>
                            }

                            {(producto.unidadMedida) &&
                                <TableCell>{ producto.unidadMedida }</TableCell>
                            }

                            {(producto.terminados) &&
                                <TableCell scope="col">{ producto.terminados.nombre }</TableCell>
                            }

                            {(producto.disenio) &&
                                <TableCell>{ producto.disenio }</TableCell>
                            }

                            {(producto.talla) &&
                                <TableCell>{ producto.talla }</TableCell>
                            }

                            {(validarRole) &&
                                <>
                                    <TableCell>
                                        {`$${separadorMillares((producto[VALOR_PRECIO[producto?.op?.view]] || 0) / producto.cantidad)}`}
                                    </TableCell>
                                    <TableCell>{`$${separadorMillares(producto[VALOR_PRECIO[producto?.op?.view]] || 0)}`}</TableCell>
                                </>
                            }
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            }
        </>
    )
    
}
